<!--
  - Copyright (c) 2019. Botanická zahrada Přírodovědecké fakulty Univerzity Karlovy, Juraj Šimon
  -->

<template>
  <sticky-header header-class-name="page-header">
    <div class="page-header-mobile">
      <mobile-header />
    </div>
    <div class="page-header-desktop">
      <left-column></left-column>
      <right-column :search.sync="search"></right-column>
    </div>
  </sticky-header>
</template>
<script>
import StickyHeader from "./common/sticky-header";
import LeftColumn from "./page-header/left-column";
import RightColumn from "./page-header/right-column";
import MobileHeader from "./page-header/mobile-header";

export default {
  name: "page-header",
  components: {
    LeftColumn,
    RightColumn,
    StickyHeader,
    MobileHeader
  },
  data() {
    return {
      search: this.$route.query.q || ""
    };
  },
  beforeRouteUpdate(to, from, next) {
    if (this.$route.query.q) {
      this.search = this.$route.query.q;
    } else {
      this.search = "";
    }
    next();
  }
};
</script>

<style lang="scss" scoped>
@import "./../styles/index";

.spacer {
  flex-grow: 1;
}
</style>

<style lang="scss">
@import "page-header-unscoped";

.page-header-mobile {
  @include desktop {
    display: none;
  }
}

.page-header-desktop {
  display: flex;
  justify-content: space-between;
  @include touch {
    display: none;
  }
}
</style>
